var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PromoBanner', {
    on: {
      "apply-event-banner": _vm.applyEventBannerStyles
    }
  }), _c('SectionHero', {
    attrs: {
      "selectedBlueprint": _vm.timelineItem,
      "isEventBannerVisible": _vm.hasEventBanner
    },
    on: {
      "send-selected-segment": _vm.setSelectedTimelineItem,
      "scroll-to-blueprint": _vm.scrollToBlueprint,
      "back-button-clicked": _vm.handleBackButtonClick
    }
  }), _vm.timelineItem && _vm.selectedVideo ? _c('SelectedSectionVideo', {
    ref: "videoSection",
    attrs: {
      "videoItem": _vm.selectedVideo
    }
  }) : !_vm.selectedVideo && !_vm.selectedRoadmapTimeline ? _c('HomePageVideo') : _vm._e(), _c('section', {
    staticClass: "mt-3",
    attrs: {
      "id": "blueprint-options-list-container"
    }
  }, [_c('div', {
    staticClass: "container-fluid px-3 px-lg-5 px-xl-5"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    staticClass: "px-0"
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-content-start w-100"
  }, [_vm.selectedRoadmapTimeline ? _c('div', [_c('div', {
    staticClass: "d-flex flex-row justify-content-center section-title w-100"
  }, [_c('span', {
    staticClass: "m-0"
  }, [_vm._v("BLUEPRINT")])]), _c('div', {
    staticClass: "d-flex flex-row justify-content-center w-100"
  }, [_c('span', {
    staticClass: "project-spectrum-title m-0 text-center"
  }, [_vm._v("Don't know where to start?")])]), _c('div', {
    staticClass: "d-flex flex-row justify-content-center w-100"
  }, [_c('span', {
    staticClass: "project-spectrum-title m-0 text-center"
  }, [_vm._v("Let's build a quick road map for you")])])]) : _vm._e(), _c('div', {
    staticClass: "blueprint-options d-flex flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column justify-content-center",
    class: {
      'align-items-center': !_vm.isBlueprintOptionsOpened,
      'align-items-lg-start align-items-xl-start align-items-sm-center align-items-center': _vm.isBlueprintOptionsOpened
    }
  }, [_c('div', {
    staticClass: "blueprint-option-title",
    class: {
      'mb-2': !_vm.isBlueprintOptionsOpened,
      'mt-3': _vm.isBlueprintOptionsOpened
    }
  }, [_vm._v(" I am here because I want to learn ")]), _c('div', {
    staticClass: "blueprint-options-container",
    class: _vm.computeBlueoptionsLeftMargin,
    attrs: {
      "id": "blueprint-options-list"
    }
  }, [_c('div', {
    staticClass: "blueprint-option-item d-flex flex-column justify-content-center pl-2 mb-2",
    on: {
      "click": function ($event) {
        _vm.isBlueprintOptionsOpened = !_vm.isBlueprintOptionsOpened;
      }
    }
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "p-0 d-flex justify-content-start align-items-center",
    attrs: {
      "cols": "11"
    }
  }, [_vm._v(" " + _vm._s(!_vm.timelineItem ? "Select an option" : `more on ${_vm.selectedBlueprintItemValue}`) + " ")]), _c('v-col', {
    staticClass: "p-0 pr-1 d-flex justify-content-center",
    attrs: {
      "cols": "1"
    }
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "max-width": "100% !important"
    },
    attrs: {
      "size": "2x",
      "icon": _vm.isBlueprintOptionsOpened ? 'chevron-up' : 'chevron-down'
    }
  })], 1)], 1)], 1)], 1), _vm._l(_vm.blueprintOptionItems, function (option) {
    return _vm.isBlueprintOptionsOpened ? _c('div', {
      key: option.optionItem,
      staticClass: "blueprint-option-item d-flex flex-column justify-content-center pl-2 mb-2",
      class: {
        'selected-blueprint-option': option.optionItem === _vm.timelineItem
      },
      on: {
        "click": function ($event) {
          return _vm.setTimelinelineItemOption(option.optionItem);
        }
      }
    }, [_vm._v(" " + _vm._s(option.optionValue) + " ")]) : _vm._e();
  })], 2)])])])], 1)], 1)]), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.timelineItem !== null && _vm.selectedRoadmapTimeline,
      expression: "timelineItem !== null && selectedRoadmapTimeline"
    }],
    staticClass: "section pt-0 pb-0 mt-5"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section-cybersecurity z-index9"
  }, [_c('h2', {
    staticClass: "project-spectrum-title text-center text-sm-start"
  }, [_vm._v(_vm._s(_vm.roadmapTimelineTitle))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('RoadmapTimeline', {
    attrs: {
      "timelineItems": _vm.selectedRoadmapTimeline
    }
  })], 1)])])]), _c('section', {
    staticClass: "section pt-0",
    staticStyle: {
      "padding-bottom": "50px"
    },
    attrs: {
      "id": "news"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "wow fadeIn",
    attrs: {
      "data-wow-duration": "1s"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('newsLists')], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center mt-4"
  }, [_c('ButtonReadMore', {
    attrs: {
      "link": {
        name: 'news'
      },
      "clickHandler": function () {
        return _vm.activateMenuItemTab('Cyber Corner');
      }
    }
  }, [_vm._v("Read More")])], 1)]), _c('section', [_c('div', {
    staticClass: "container-fluid company-partners-container d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex flex-row flex-fill company-partners-container-text-info pt-5",
    style: {
      'marginBottom': _vm.computeCompanyPartnerTextContainerClass
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-center d-flex flex-row justify-content-xl-end align-items-xl-center justify-content-lg-end align-items-lg-center justify-content-center align-items-end p-0 pr-2",
    class: _vm.computeCompanyPartnerTextClass,
    attrs: {
      "xl": "6",
      "lg": "6",
      "cols": "12"
    }
  }, [_vm._v(" Project Spectrum serves 15000+ ")]), _c('v-col', {
    staticClass: "text-center d-flex flex-row justify-content-xl-start align-items-xl-center justify-content-lg-start align-items-lg-center justify-content-center p-0 pl-0",
    class: _vm.computeCompanyPartnerTextClass,
    attrs: {
      "xl": "6",
      "lg": "6",
      "cols": "12"
    }
  }, [_vm._v(" companies under these partnerships ")])], 1)], 1), _c('div', {
    staticClass: "d-flex flex-row flex-fill"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pl-0 pr-0",
    attrs: {
      "xl": "4",
      "lg": "4",
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 d-flex align-items-center"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('../assets/images/logo/company-partners/image_32.png'),
      "max-width": "40%",
      "contain": ""
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('../assets/images/logo/company-partners/image_35.png'),
      "max-width": "80%",
      "contain": ""
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('../assets/images/logo/company-partners/image_36.png'),
      "max-width": "40%",
      "contain": ""
    }
  })], 1)], 1)], 1)]), _c('v-col', {
    staticClass: "pr-0 pl-0",
    attrs: {
      "xl": "4",
      "lg": "4",
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 d-flex align-items-center"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('../assets/images/logo/company-partners/image_37.png'),
      "max-width": "40%",
      "contain": ""
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('../assets/images/logo/company-partners/image_38.png'),
      "max-width": "80%",
      "contain": ""
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('../assets/images/logo/company-partners/image_39.png'),
      "max-width": "70%",
      "contain": ""
    }
  })], 1)], 1)], 1)]), _c('v-col', {
    staticClass: "pl-0 pr-0",
    attrs: {
      "xl": "4",
      "lg": "4",
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 d-flex align-items-center"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('../assets/images/logo/company-partners/image_40.png'),
      "max-width": "60%",
      "contain": ""
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('../assets/images/logo/company-partners/image_41.png'),
      "max-width": "40%",
      "contain": ""
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex justify-content-center pl-0 pr-0 last-image-class",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('../assets/images/logo/company-partners/image_42.png'),
      "max-width": "100%",
      "contain": ""
    }
  })], 1)], 1)], 1)])], 1)], 1)])]), _c('section', [_c('div', {
    staticClass: "container-fluid customer-relationship-container"
  }, [_c('div', {
    staticClass: "container customer-relationship-content"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center customer-relationship-title",
    style: {
      'fontSize': _vm.resizeCustomerTitle
    }
  }, [_vm._v(" The Relationship with the Department of Defense ")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "customer-relationship-text"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo/check.png"),
      "alt": ""
    }
  }), _vm._v("   "), _c('span', [_vm._v("The Department of Defense has entrusted Project Spectrum to be the cornerstone of cybersecurity for small and mid-size businesses of Defense Industrial Base.")])]), _c('div', {
    staticClass: "customer-relationship-text"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo/check.png"),
      "alt": ""
    }
  }), _vm._v("   "), _c('span', [_vm._v("Select \"Get Started Today!\" to begin your cybersecurity journey.")])])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "button-container"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": "#424EC4"
    },
    on: {
      "click": _vm.goToCyberReadinessCheck
    }
  }, [_vm._v(" Get Started Today! ")])], 1)])], 1)], 1)])]), _vm.isLoggedIn ? _c('InvitationModal', {
    ref: "invitation-modal",
    on: {
      "invite-accepted": _vm.getAccountData
    }
  }) : _vm._e(), _vm.isLoggedIn ? _c('JoinRequestModal', {
    ref: "join-request-modal",
    on: {
      "request-accepted": _vm.getAccountData
    }
  }) : _vm._e(), _c('b-modal', {
    ref: "welcome-admin-modal",
    attrs: {
      "size": "md",
      "title": "Welcome",
      "ok-only": ""
    }
  }, [_c('p', {
    staticClass: "my-2"
  }, [_vm._v(" We are happy to welcome you as the newest organization within Project Spectrum community! As an organization admin, you will be able to leverage the plethora of tools and services offered by Project Spectrum, including: Cyber Readiness Checks, advisory services, and assistance with every step of your customized cybersecurity journey. Additionally, you will have the ability to invite new members of your organization and manage them accordingly to gain insights into their individual training progress. Please feel free to take advantage of all of the resources at your disposal as well. We offer Cyber Readiness Checks for your organization, personalized cybersecurity training, virtual labs, informational webinars, Cyber Circuits Sessions (hear from industry experts), white papers, blogs, compliance tool reviews, and much more! ")])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text-center section-title"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("READ OUR")]), _c('h2', {
    staticClass: "project-spectrum-title"
  }, [_vm._v("Latest News")])])]);

}]

export { render, staticRenderFns }